<template>
  <div>
    <!--Stats cards-->
    <div class="row equal">
      <div class="col-lg-6 col-md-6 col-sm-12 d-flex">
        <StatsCard
          v-bind:businessId="basicCards[0].businessId"
          v-bind:dataType="basicCards[0].dataType"
          v-bind:recordType="basicCards[0].recordType"
          v-bind:cardType="basicCards[0].cardType"
          v-bind:cardTitle="basicCards[0].cardTitle"
          v-bind:comparisonField1="'pageSpeedScore'"
          v-bind:comparisonField2="'speedIndex'"
          v-bind:comparisonField1Label="'Speed Score'"
          v-bind:comparisonField2Label="'Load Time'"
          v-bind:lowerIsBetter1="false"
          v-bind:lowerIsBetter2="true"
        ></StatsCard>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 d-flex">
        <div class="card-wrapper">
          <MapCard></MapCard>
        </div>
      </div>
    </div>
    <div class="row equal">
      <div class="col-lg-6 col-md-6 col-sm-12 d-flex">
        <StatsCard
          v-bind:businessId="basicCards[1].businessId"
          v-bind:dataType="basicCards[1].dataType"
          v-bind:recordType="basicCards[1].recordType"
          v-bind:cardType="basicCards[1].cardType"
          v-bind:cardTitle="basicCards[1].cardTitle"
          v-bind:comparisonField1="'googleReviews.average'"
          v-bind:comparisonField2="'googleReviews.count'"
          v-bind:comparisonField1Label="'Average'"
          v-bind:comparisonField2Label="'Count'"
          v-bind:lowerIsBetter1="false"
          v-bind:lowerIsBetter2="false"
        ></StatsCard>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 d-flex">
        <StatsCard
          v-bind:businessId="basicCards[2].businessId"
          v-bind:dataType="basicCards[2].dataType"
          v-bind:recordType="basicCards[2].recordType"
          v-bind:cardType="basicCards[2].cardType"
          v-bind:cardTitle="basicCards[2].cardTitle"
          v-bind:comparisonField1="'reviews.count'"
          v-bind:comparisonField2="'reviews.average'"
          v-bind:comparisonField1Label="'Count'"
          v-bind:comparisonField2Label="'Average'"
          v-bind:lowerIsBetter1="false"
          v-bind:lowerIsBetter2="false"
        ></StatsCard>
      </div>
    </div>
    <!--<div class="col-lg-6 col-md-6 col-sm-12" v-for="item in basicCards" :key="item.id">       
        <StatsCard
          v-bind:businessId="item.businessId"
          v-bind:dataType="item.dataType"
          v-bind:recordType="item.recordType"
          v-bind:cardType="item.cardType"
          v-bind:cardTitle="item.cardTitle"></StatsCard>
        <ComparisonCard
          v-bind:businessId="item.businessId"
          v-bind:dataType="item.dataType"
          v-bind:recordType="item.recordType"
          v-bind:cardType="item.cardType"
          v-bind:cardTitle="item.cardTitle"></ComparisonCard>
      </div>-->
  </div>
</template>
<script>
import StatsCard from "src/components/UIComponents/Cards/StatsCard";
import ComparisonCard from "src/components/UIComponents/Cards/ComparisonCard";
import MapCard from "src/components/UIComponents/Cards/MapCard";

export default {
  components: {
    StatsCard,
    ComparisonCard,
    MapCard,
    StatsCard,
  },
  mounted: function () {},
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      basicCards: [
        {
          id: 0,
          businessId: localStorage.selectedBusinessId,
          dataType: "pagespeed_all",
          recordType: "summary",
          cardType: "PerformanceSummary",
          cardTitle: "Site Performance",
        },
        {
          id: 1,
          businessId: localStorage.selectedBusinessId,
          dataType: "gmb",
          recordType: "full",
          cardType: "ReviewsSummary",
          cardTitle: "Google Reviews",
        },
        {
          id: 2,
          businessId: localStorage.selectedBusinessId,
          dataType: "facebook",
          recordType: "full",
          cardType: "FacebookSummary",
          cardTitle: "Facebook Reviews",
        },
      ],
    };
  },
};
</script>
<style></style>
